import { CoreAudit } from "shared/cubiq-services/model/core/CoreAudit";

/**
 * Audit class for Benchmark audits (actually fixing audits but more
 * commonly knwon as BM) - actual BM orders are audited using CoreOrderAudit
 */
export class CoreBenchmarkAudit extends CoreAudit {}
